import getMemberToken from '../../utils/getMemberToken';
import {WEDDINGS_API_HOST, WEDDINGS_API_KEY} from '../../constants/app';

const memberSessionToken = getMemberToken();

const getHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'MEMBERSHIP-SESSION-TOKEN': memberSessionToken,
});

const WeddingsApi = {
  getWedding: async memberId => {
    if (!memberId) {
      throw new Error('member id cannot be empty.');
    }
    const response = await fetch(
      `${WEDDINGS_API_HOST}/members/${memberId}/wedding?api_key=${WEDDINGS_API_KEY}`,
      {
        method: 'GET',
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error('Error getting member wedding data', response);
    }

    return response.json();
  },
  updateWedding: async (memberId, guestRange) => {
    if (!memberId) {
      throw new Error('member id cannot be empty.');
    }
    const response = await fetch(
      `${WEDDINGS_API_HOST}/weddings?api_key=${WEDDINGS_API_KEY}`,
      {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({
          wedding: {
            member_id: memberId,
            guest_range: guestRange,
          },
        }),
      },
    );

    if (!response.ok) {
      throw new Error('Error updating member wedding data', response);
    }

    return response.json();
  },
};

export default WeddingsApi;
